import { z } from 'zod';
export var TextItem = z.object({
    ID: z.string().prefault(''),
    text: z.string().prefault('')
});
export var Contact = z.object({
    ID: z.string().prefault(''),
    firstName: z.string().prefault(''),
    lastName: z.string().prefault(''),
    localDeviceID: z.string().prefault(''),
    imageBase64: z.string().prefault(''),
    imageAssetKey: z.string().optional(),
    phone: z.string().prefault('')
});
export var Place = z.object({
    ID: z.string().prefault(''),
    name: z.string().prefault(''),
    latitude: z.number().prefault(0),
    longitude: z.number().prefault(0)
});
